import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface EstatusPreguntaAsamblea {
  eps_codigo: string;
  eps_nombre: string;
}

export const obtenerEstatusPreguntaAsamblea = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusPreguntaAsamblea[]>>(
    "estatus_pregunta_asamblea/ObtenerTodos",
    HttpMethod.POST,
    {}
  );

  return envelope;
};
